import { getEnv } from '@/utils/common'

export const ENV_LOCAL = 'local'
export const ENV_DEV = 'dev'
export const ENV_PRD = 'prod'

export const API_DOMAIN = 'mincaresys.taskmanage.site'

let apiUri = ''
switch (getEnv()) {
  case ENV_PRD:
    apiUri = 'https://' + API_DOMAIN
    break
  case ENV_DEV:
    apiUri = 'https://dev.' + API_DOMAIN
    break
  default:
    apiUri = 'https://' + API_DOMAIN
    break
}
export const API_URI = apiUri

export const ENDPOINT_SANCTUM_CSRF_COOKIE = API_URI + '/sanctum/csrf-cookie'
export const ENDPOINT_LOGIN = API_URI + '/api/auth/login'
export const ENDPOINT_LOGOUT = API_URI + '/api/auth/logout'
export const ENDPOINT_ME = API_URI + '/api/v1/user/me'
export const ENDPOINT_MESSAGE = API_URI + '/api/v1/message'
export const ENDPOINT_MESSAGE_READ = API_URI + '/api/v1/message/read'
export const ENDPOINT_MESSAGES = API_URI + '/api/v1/messages'
export const ENDPOINT_USER_REGISTER = API_URI + '/api/v1/user/register'
export const ENDPOINT_USER_REGISTER_CONFIRM =
  API_URI + '/api/v1/user/register/confirm'
export const ENDPOINT_USER_PROFILE = API_URI + '/api/v1/user/profile'
export const ENDPOINT_USER_SEARCH = API_URI + '/api/v1/user/search'
export const ENDPOINT_CONTACT = API_URI + '/api/v1/contact'
export const ENDPOINT_CONTACTS = API_URI + '/api/v1/contacts'
export const ENDPOINT_CHAT = API_URI + '/api/v1/chat'
export const ENDPOINT_CHATS = API_URI + '/api/v1/chats'
export const ENDPOINT_CHAT_MEMBERS = API_URI + '/api/v1/chat_members'
export const ENDPOINT_CHAT_MEMBER = API_URI + '/api/v1/chat_member'
export const ENDPOINT_CHAT_OWNER = API_URI + '/api/v1/chat_owner'
export const ENDPOINT_RECORDS = API_URI + '/api/v1/records'
export const ENDPOINT_RECORD = API_URI + '/api/v1/record'
export const ENDPOINT_FILES = API_URI + '/api/v1/files'
export const ENDPOINT_FILE = API_URI + '/api/v1/file'
export const ENDPOINT_FORGOT_PASSWORD = API_URI + '/api/v1/user/forgot/password'
export const ENDPOINT_POSTCODE_API = 'https://zip-cloud.appspot.com/api/search'
export const ENDPOINT_SCHEDULES = API_URI + '/api/v1/schedules'
export const ENDPOINT_SCHEDULE = API_URI + '/api/v1/schedule'
export const ENDPOINT_RESET_PASSWORD = API_URI + '/api/v1/user/reset/password'
export const ENDPOINT_BUSINESS_PROFILE = API_URI + '/api/v1/business/profile'
export const ENDPOINT_USER_IDENTIFICATION =
  API_URI + '/api/v1/user/identification'
export const ENDPOINT_STAFF = API_URI + '/api/v1/staff'
export const ENDPOINT_STAFFS = API_URI + '/api/v1/staffs'
export const ENDPOINT_INVITED_STAFFS = API_URI + '/api/v1/invited_staffs'
export const ENDPOINT_STAFF_CHATS = API_URI + '/api/v1/staff_chats'
export const ENDPOINT_STAFF_HISTORIES = API_URI + '/api/v1/staff_histories'
export const ENDPOINT_STAFF_MONTHLY_USAGE =
  API_URI + '/api/v1/staff_monthly_usage'
export const ENDPOINT_STAFF_MONTHLY_USAGE_DETAIL =
  API_URI + '/api/v1/staff_monthly_usage_detail'
export const ENDPOINT_SAMPLE = API_URI + '/api/v1/sample'
